



































































import { Component, Vue, Prop } from "vue-property-decorator";
import { mapGetters } from "vuex";
@Component({
    ...mapGetters(["accountBook"]),
    components: {
    }
})
export default class ImportDayAccount extends Vue {
    @Prop({ type: String })
    period!: string;

    banks: { key: string; value: boolean; }[] = [];
    mounted() {
        this.fetchBanks();
    }

    isCurr = false;
    fetchBanks() {
        Vue.axios
            .post(`journals/openingbanks?accountBookId=${this.$store.state.accountBook.id}`)
            .then(res => {
                this.isCurr = res.data.isCurr;
                const list: { key: string; value: boolean; }[] = [];
                Object.keys(res.data.openingBanks).forEach(v => {
                    list.push({
                        key: v,
                        value: res.data.openingBanks[v]
                    });
                });
                this.banks = list;
                this.getBanks();
            });
    }
    // 开户行改为可自定义新增的下拉框
    openingBank: { key: string; value: boolean; } | null | "" = null;
    getBanks() {
        if (this.banks.length > 0) this.openingBank = this.banks[0];
        else this.openingBank = null;
    }
    // 导入对账单
    file: any = "";
    form: any = "";
    exchangeRateVal = "";
    get exchangeRate(): string {
        if (this.openingBank !== null && this.openingBank !== "") {
            if (this.openingBank.value) return this.exchangeRateVal;
            else this.exchangeRateVal = "";
        } else {
            if (this.isCurr) return this.exchangeRateVal;
            else this.exchangeRateVal = "";
        }
        return "";
    }
    changeFile(e: any) {
        if (e.target.files[0]) {
            this.file = e.target.files[0];
            let data = new FormData();
            data.append("file", this.file);
            data.append("accountBookId", this.$store.state.accountBook.id);
            data.append("fileName", this.file.name);
            data.append("endPeriod", this.period);
            this.form = data;
        }
    }
    
    // 开户行失去焦点
    blurBank(e: any) {
        // this.openingBank = e.target.value;
    }
    // 确定
    confirm() {
        if (this.file != "") {
            this.form.append("openingBank", this.openingBank !== null && this.openingBank !== undefined && this.openingBank !== "" ? this.openingBank.key : "");
            this.form.append("exchangeRate", this.exchangeRate);
            Vue.axios
                .post(`journals/import`, this.form)
                .then(res => {
                    this.$alert(res.data.data, "温馨提示");
                    this.$emit("close", true);
                });
        }
    }
}
